import PropTypes from "prop-types";
import React, { Component } from "react";
import DataTable from "../app/DataTable";

const defaultValue = { symbol: "", shares: "ALL", handling: "", account_number: "" };
const handlingOptions = ["In Kind", "Liquidate"];

function getValue(value) {
  if (!value) {
    return [{ ...defaultValue }];
  }
  try {
    return JSON.parse(value);
  } catch (_err) {
    return [{ ...defaultValue }];
  }
}

export default class DataTableInput extends Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    mutualFunds: PropTypes.bool,
    hideShares: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const data = getValue(props.value);
    this.state = {
      data,
    };
  }

  get columns() {
    const columns = [{ accessor: "symbol", Header: "Symbol or fund name", Cell: this.renderEditable }];
    if (!this.props.hideShares) {
      columns.push({ accessor: "shares", Header: "Shares", Cell: this.renderEditable });
    }
    if (this.props.mutualFunds) {
      columns.push({ accessor: "handling", Header: "Handling", Cell: this.renderSelect });
      columns.push({ accessor: "account_number", Header: "Fund account number", Cell: this.renderEditable });
    }
    columns.push({ Cell: this.renderActions, maxWidth: 75 });
    return columns;
  }

  renderActions = (cell) => {
    return (
      <button
        type="button"
        className="app-btn app-btn--default app-btn--xs waves-effect waves-light app-float-end"
        onClick={(_e) => {
          const data = [...this.state.data];
          data.splice(cell.index, 1);
          this.setState({ data }, () => {
            this.props.onChange(JSON.stringify(this.state.data));
          });
        }}
      >
        × Remove
      </button>
    );
  };

  renderSelect = (cell) => {
    const value = this.state.data[cell.index][cell.column.id];
    return (
      <select
        style={{ width: "100%" }}
        value={value}
        onChange={(e) => {
          const data = [...this.state.data];
          data[cell.index][cell.column.id] = e.target.value;
          this.setState({ data }, () => {
            this.props.onChange(JSON.stringify(this.state.data));
          });
        }}
      >
        {handlingOptions.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>
    );
  };

  renderEditable = (cell) => {
    return (
      // oxlint-disable-next-line jsx-a11y/no-static-element-interactions -- This is an intentionally editable table cell.
      <div
        style={{ backgroundColor: "#fafafa", padding: "2px 5px" }}
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => {
          const data = [...this.state.data];
          data[cell.index][cell.column.id] = e.target.textContent;
          this.setState({ data }, () => {
            this.props.onChange(JSON.stringify(this.state.data));
          });
        }}
      >
        {String(this.state.data[cell.index][cell.column.id] ?? "")}
      </div>
    );
  };

  addRow = (_e) => {
    const data = this.state.data;
    data.push({ ...defaultValue });
    this.setState({ data });
  };

  render() {
    const { data } = this.state;
    return (
      <div>
        <DataTable key={data.length} data={data} columns={this.columns} sortable={false} pageSize={data.length + 1} />
        <div className="app-layout-row">
          <div className="app-col-sm-2 app-col-sm-offset-10">
            <button
              type="button"
              className="app-btn app-btn--primary app-btn--sm waves-effect waves-light app-float-end margin-top-10"
              onClick={this.addRow}
            >
              + Add
            </button>
          </div>
        </div>
      </div>
    );
  }
}
